"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToClientType = exports.ClientTypeSchema = exports.ClientType = exports.castToChannelType = exports.ChannelTypeSchema = exports.ChannelType = exports.castToPaymentProcessorType = exports.PaymentProcessorTypeSchema = exports.PaymentProcessorType = void 0;
const core_1 = require("../core");
const cast_1 = require("../utils/cast");
var PaymentProcessorType;
(function (PaymentProcessorType) {
    PaymentProcessorType["STRIPE"] = "STRIPE";
})(PaymentProcessorType = exports.PaymentProcessorType || (exports.PaymentProcessorType = {}));
exports.PaymentProcessorTypeSchema = (0, core_1.StringUnion)([PaymentProcessorType.STRIPE], {
    title: "Payment Processor",
    description: "Processor used to collected payments ",
});
exports.castToPaymentProcessorType = (0, cast_1.castToEnum)(PaymentProcessorType);
var ChannelType;
(function (ChannelType) {
    ChannelType["APPLE_SEARCH_RESULTS"] = "APPLE_SEARCH_RESULTS";
    ChannelType["APPLE_SEARCH_TABS"] = "APPLE_SEARCH_TABS";
    ChannelType["APPLE_TODAY_TABS"] = "APPLE_TODAY_TABS";
    ChannelType["PRODUCT_PAGE_BROWSE"] = "PRODUCT_PAGE_BROWSE";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
exports.ChannelTypeSchema = (0, core_1.StringUnion)([
    ChannelType.APPLE_SEARCH_RESULTS,
    ChannelType.APPLE_SEARCH_TABS,
    ChannelType.APPLE_TODAY_TABS,
    ChannelType.PRODUCT_PAGE_BROWSE,
], {
    title: "Channel Type",
    description: "The Ad Channel type",
});
exports.castToChannelType = (0, cast_1.castToEnum)(ChannelType);
var ClientType;
(function (ClientType) {
    ClientType["SELF_SERVE"] = "SELF_SERVE";
    ClientType["MANAGED"] = "MANAGED";
    ClientType["INACTIVE"] = "INACTIVE";
})(ClientType = exports.ClientType || (exports.ClientType = {}));
exports.ClientTypeSchema = (0, core_1.StringUnion)([ClientType.INACTIVE, ClientType.MANAGED, ClientType.SELF_SERVE], {
    title: "Client type",
    description: "The type of client for any given team",
});
exports.castToClientType = (0, cast_1.castToEnum)(ClientType);
